
import React, { useEffect, useRef, useState } from 'react';
import { DataTable, DataTableFilterMeta, DataTableRowEditCompleteEvent } from 'primereact/datatable';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber, InputNumberValueChangeEvent } from 'primereact/inputnumber';
import { LazyTableState } from 'src/models/components/dataTableWrapperModel';
import { graceTimeListLoading, updateGraceTimeLoading, } from 'src/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducerState } from 'src/store/reducers';
import { incentive } from 'src/models/pages/incentiveModels';
import Button from 'src/components/UI/Button';
import { useToast } from 'src/components/Common/ReactToaster';
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';





export default function GraceTimeConfig() {
  const [products, setProducts] = useState<incentive[] | any>();
  
  const { graceTimeList, error, loading, message } = useSelector((state: RootReducerState) => state.incentiveReducer)

  const dispatch = useDispatch();
  const filterDetails: DataTableFilterMeta = {
    UserId: { value: "", matchMode: "contains" },
  };
  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };
  
  const [lazyState, setLazyState] = useState(initialLazyState);
  useEffect(() => {
    const modifiedData = graceTimeList.values.map((data: any) => {
      let object = {
        id: data.id,
        currentStatusName: data.currentStatusName,
        granceMinutes: data.granceMinutes ? data.granceMinutes : 0,
      }
      return object
    })
    setProducts(modifiedData)
  }, [graceTimeList]);

  const { showToast } = useToast();

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);
  const [visible, setVisible] = useState(false);
  useEffect(() => {

    if (error) {
      setVisible(true);
      // showToast(error, { type: "error" })
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(graceTimeListLoading(lazyState));
    }
  }, [error, message]);

  const onRowEditComplete = (e: DataTableRowEditCompleteEvent) => {
    let _products = [...products];
    let { newData, index } = e;

    _products[index] = newData as any;
    

    setProducts(_products);
  };


  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const RewardEditor = (options: ColumnEditorOptions) => {

    return <InputNumber inputRef={inputRef} value={options.value} min={0} onValueChange={(e: InputNumberValueChangeEvent) => options.editorCallback!(e.value)} />;
  };


  const header =
    <div className="table-header-container">
      <div>Grace Time Config</div>
      <div className="table-header-container-item table-header-container-item-special">

      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
      </div>

    </div>;

  const hidePopup = () => {
    setVisible(false);
    // dispatch(incentiveListLoading(lazyState));
  }

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };


  const allowEdit = (rowData: any) => {
    if (rowData && rowData.name !== 'Blue Band') {
      return true;
    }
    return false
  };

  const callbackFunction = (lazyState: LazyTableState) => {
    dispatch(graceTimeListLoading(lazyState));
  };

  useEffect(() => {
    callbackFunction(lazyState);
  }, [])

  const handleSubmit = () => {

    dispatch(updateGraceTimeLoading(products))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        {visible && dialogContainer(error)}
        <DataTable reorderableColumns header={header} value={products} editMode="column" dataKey="id" onRowEditComplete={onRowEditComplete} tableStyle={{ minWidth: '50rem' }}
        scrollable
        scrollHeight="700px"
        stripedRows
        >
          <Column frozen field="currentStatusName" header="Status" style={{ width: '20%' }}></Column>
          <Column field="granceMinutes" header="Grace Minutes" editor={(options) => RewardEditor(options)} style={{ width: '20%' }}></Column>
          <Column rowEditor={allowEdit(products)} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
        </DataTable>
        <div className="d-flex justify-content-end mt-2">
          <Button
            className="secondary-btn me-2"
            label={"Reset"}
            type="button"
            onClick={() => { dispatch(graceTimeListLoading(lazyState)) }}
          />
          <Button
            className="btn-primary me-2"
            label={"Update Grace Time"}
            onClick={() => handleSubmit()}
            type="button"
          />
        </div>
      </div>
    </React.Fragment>
  );
}

